import { FC, useState } from 'react';
import SubscribeModal from '@pro/common/SubscribeModal';
import { ISubscribeFormProps, SubscribeForm } from 'mod/subscribe/SubscribeForm';

type ISubscribeProps = ISubscribeFormProps & {
    title?: false | string;
    tip?: string;
};

export const Subscribe: FC<ISubscribeProps> = props => {
    const {
        className,
        title,
        tip,
        ...rest
    } = props;

    const [visible, setVisible] = useState<boolean>(false);

    return (
        <div className={className}>
            {!!title && (<div className="g-title">{title}</div>)}

            <SubscribeForm
                {...rest}
                className={'g-form'}
                onSuccess={() => setVisible(true)}
            />

            <SubscribeModal
                visible={visible}
                onCancel={() => setVisible(false)}
            />
        </div>
    )
};